<template>
<v-row justify="center">
    <v-dialog v-model="shower" scrollable persistent max-width="760">    
      <v-card>
        <v-card-title>{{$t('keydetail.details')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="loaddataprogress === true" class="text-center">
          <v-progress-circular indeterminate size="64" :color="color.theme">
            
            <span :style="colorProgress">&nbsp; &nbsp; loading</span>
          </v-progress-circular>
        </div>
      <v-subheader>{{$t('packagenew.detail_pac')}}<v-divider class="mx-4" ></v-divider></v-subheader>
          <v-list>
            <template>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="line-height: 26px;">{{$t('packagenew.detail')}} {{$t("default") === 'th' ? package_detail_all : package_detail_all_eng}}</v-list-item-title>
                </v-list-item-content>
                <!-- <v-list-item-action>
                  <v-list-item-title :style="darkModeText">{{ package_detail_all }}</v-list-item-title>
                </v-list-item-action> -->
              </v-list-item>
            </template>
          </v-list>
          <v-list v-if="package_name_main !== ''">
            <template>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{$t('packagenew.package')}} {{package_name_main}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title style="line-height: 26px;">{{ $t("default") === 'th' ? detail_main : detail_main_eng }}</v-list-item-title>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
          <v-list v-if="detail_addon !== ''">
            <template>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{package_name_addon}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title style="line-height: 26px;">{{ $t("default") === 'th' ? detail_addon : detail_addon_eng }}</v-list-item-title>
                </v-list-item-action> 
              </v-list-item>
            </template>
          </v-list>
            <v-list>
                <template>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('packagenew.pricenonvat')}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-title>{{$t("default") === 'th' ? amount : amount_eng}}</v-list-item-title>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
          <v-list v-if="discount !== ''">
            <template>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{$t('packagenew.discount')}}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t("default") === 'th' ? discription_discount : discription_discount_eng }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title style="line-height: 26px;">{{$t("default") === 'th' ? discount : discount_eng}}</v-list-item-title>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
            <v-list>
                    <template>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{$t('packagenew.vat_')}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-list-item-title style="line-height: 26px;">{{$t("default") === 'th' ? vat : vat_eng}}</v-list-item-title>
                        </v-list-item-action> 
                      </v-list-item>
                    </template>
                  </v-list>
                  <v-list>
                    <template>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title style="line-height: 2ุ6px;">{{$t('packagenew.price_vat')}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-list-item-title style="line-height: 30px;">{{$t("default") === 'th' ? total_amount : total_amount_eng}}</v-list-item-title>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                
         <v-layout>
       <!-- <p class="pl-4 ma-2">
          ใบกำกับภาษี&nbsp;
        </p>
        <v-radio-group class="pl-8 ma-2" v-model="typeinvoice">
        <v-radio label="รับ" value="Y"></v-radio>
        <v-radio label="ไม่รับ" value="N"></v-radio>
        </v-radio-group> -->
         </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('closedialog')" color="red" dark>{{$t('keydetail.closeDialog')}}</v-btn>
          <v-btn color="primary" class="pa-1 pt-0 white--text" @click="fn_check_taxinvioce()">{{
          $t("changeName.submit")
        }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <dialogtaxinvoice
      :show="opendialogtaxinvioce"
      @closedialog="opendialogtaxinvioce = false"
      @closeandpay="opendialogtaxinvioce = false,$emit('confirmbuypackage');"
      @closenotpay="(opendialogtaxinvioce = false)"
  ></dialogtaxinvoice>
  </v-row>  
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css";
import "swiper/css/swiper.css";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
const dialogtaxinvoice = () => import("../optional/dialog-tax-invoice-citizen.vue");

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
    props: ["show","payload_package","account_id"],
    components: { dialogtaxinvoice },
    data: function(){ 
      return {
        detail_addon_eng:"",
        discription_discount_eng:"",
        loaddataprogress:false,
        opendialogtaxinvioce:false,
        typeinvoice:"",
        discription_discount:"",
        discount:"",
        package_name_main:"",
        package_name_addon:"",
        package_detail_all:"",
        amount:"",
        vat:"",
        total_amount:"",
        detail_main:"",
        detail_main_eng:"",
        detail_addon:"",
        package_detail_all_eng:"",
        amount_eng:"",
        vat_eng:"",
        total_amount_eng:"",
        discount_eng:""
      };
    },
    computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
      colorProgress(){
        return 'color:'+this.color.theme+';'
      },
    // darkModeText() {
    //   return this.$vuetify.theme.dark ? "color: white;" : "color: black"
    // },
    },
    methods:{

    async fn_check_taxinvioce(){
      let payload = {
        account_id: this.account_id,
      };
       let auth = await gbfGenerate.generateToken();
      this.axios
        .post(process.env.VUE_APP_SERVICE_ADMIN + "/api/v1/detail/address", payload ,{
            headers: { Authorization: auth.code },
          })
        .then((response) => {
          if (response.data.status === "OK") {
              this.$emit('confirmbuypackage');
            // this.taxInvoice = true;
            // this.address = response.data.address
            // this.tax_num = response.data.result.taxid;
            // this.noaddress = response.data.result.HouseNumber;
            // this.building = response.data.result.BuildingName;
            // this.floor = response.data.result.FloorNumber;
            // this.road = response.data.result.StreetName;
            // this.subdistrict = response.data.result.Thambol;
            // this.district = response.data.result.Amphur;
            // this.province = response.data.result.Province;
            // this.postcode = response.data.result.PostCode;
            // this.typebusiness = response.data.result.business_TitleName_th;
            // this.name_business_th = response.data.result.business_name;
            // this.typebusiness_eng = response.data.result.business_TitleName_en;
            // this.radios = response.data.result.BranchNumber === "00000" ? "สำนักงานใหญ่" : "สาขาอื่นๆ";
            // this.branch_no = response.data.result.BranchNumber;
            // this.branch_name = response.data.result.branchname;
            // this.email_business = response.data.result.email
            // this.tel_biz = response.data.result.phone_numbers
            // this.mooban = response.data.result.MooName
            // this.no_moo = response.data.result.MooNumber
            // this.noroom = response.data.result.RoomNumber
            // this.yaek = response.data.result.Separate
            // this.soi = response.data.result.SoiName
            // this.fax = response.data.result.fax_number
            // this.name_invoice_th = response.data.result.full_business_name
            // this.phone_number_biz= response.data.result.telephone_number
          } else {
            this.opendialogtaxinvioce = true;

          }
        })
        .catch((error) => {
          // console.log(error);
          // this.loaddataprogress = false;
          Toast.fire({
            icon: "error",
            title: "ไม่สามารถเรียกไฟล์ได้ในขณะนี้",
          });
        });

     
    },
    async fn_getdetail_package(){
    //  this.loaddataprogress = true; 
        let payload = this.payload_package;
         let auth = await gbfGenerate.generateToken();
        this.axios
          .post(process.env.VUE_APP_SERVICE_ADMIN_BOX + "/api/v1/detail/payment_storage", payload, {
            headers: { Authorization: auth.code },
          })
          .then((response) => {
            if (response.data.status === "OK") {
              console.log("response.data.list_detail[1]",response.data.list_detail[1]);
              
                   console.log("res*", response.data.result);
                   this.package_name_addon = response.data.result.package_name_addon;
                   this.package_name_main = response.data.result.package_name_main;
                   this.detail_main = response.data.list_detail[0] === undefined ? '' : response.data.list_detail[0].package_detail ;
                   this.detail_main_eng = response.data.list_detail[0] === undefined ? '' : response.data.list_detail[0].package_detail_eng ;
                   this.detail_addon = response.data.list_detail[1] === undefined ? '' : response.data.list_detail[1].package_detail ;
                   this.detail_addon_eng = response.data.list_detail[1] === undefined ? '' : response.data.list_detail[1].package_detail_eng ;
                   this.package_detail_all = response.data.result.package_detail_all;
                   this.package_detail_all_eng = response.data.result.package_detail_all_eng;
                   this.amount = response.data.result.amount;
                   this.amount_eng = response.data.result.amount_eng;
                   this.vat = response.data.result.vat;
                   this.vat_eng = response.data.result.vat_eng;
                   this.total_amount = response.data.result.total_amount;
                   this.total_amount_eng = response.data.result.total_amount_eng;
                   this.discount = response.data.result.discount;
                   this.discount_eng = response.data.result.discount_eng;
                   this.discription_discount = response.data.result.discription_discount;
                   this.discription_discount_eng = response.data.result.discription_discount_eng;
              this.loaddataprogress = false;
            } else {
              this.loaddataprogress = false;
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
          });

    },
    formatdatetime(_datetime) {
      if(_datetime === "" || _datetime === null || _datetime === undefined){
        return "-";
      }else{ 
        let dateyear =
          _datetime.split("")[0] +
          _datetime.split("")[1] +
          _datetime.split("")[2] +
          _datetime.split("")[3];
        let datemonth = _datetime.split("")[4] + _datetime.split("")[5];
        let dateday = _datetime.split("")[6] + _datetime.split("")[7];
        let hour = _datetime.split("")[8] + _datetime.split("")[9];
        let minute = _datetime.split("")[10] + _datetime.split("")[11];
        let second = _datetime.split("")[12] + _datetime.split("")[13];

        return (
          dateday +
          "/" +
          datemonth +
          "/" +
          dateyear +
          " " +
          hour +
          ":" +
          minute +
          ":" +
          second
        );
      }
    },
        setformatdate(_date) {
      let data =
        _date.substring(8, 6) +
        "/" +
        _date.substring(6, 4) +
        "/" +
        _date.substring(0, 4);
      return data || "-";
    },
   seticon(parameter) {
      // console.log(parameter);
      // let parameter_ = parameter !== "" || parameter !== undefined || parameter !== null ? parameter.toLowerCase() : parameter
      let dataicon;
      if (parameter === "xlsx" || parameter === "xls") {
        dataicon = ["mdi-file-excel-outline", "green"];
      } else if (parameter === "pptx" || parameter === "ppt") {
        dataicon = ["mdi-file-powerpoint-outline", "orange"];
      } else if (parameter === "pdf") {
        dataicon = ["mdi-file-pdf-outline", "red"];
      } else if (parameter === "xml") {
        dataicon = ["mdi-file-code-outline", "orange"];
      } else if (parameter === "txt" || parameter === "txt") {
        dataicon = ["mdi-note-text-outline", "blue-grey"];
      } else if (
        parameter === "jpeg" ||
        parameter === "jpg" ||
        parameter === "png"
      ) {
        dataicon = ["mdi-file-image-outline", "blue-grey"];
      } else if(parameter === "avi" ||
    parameter === "mpeg" ||
    parameter === "mov" ||
    parameter === "mp4"||
    parameter === "mkv" ||
    parameter === "wmv" ||
    parameter === "3gp" ||
    parameter === "flv"){
      dataicon = ["mdi-file-video-outline", "purple"];
    }else if(parameter === "shortcut"){
      dataicon=["mdi-file-link-outline","pink"]
    }
      else {
        dataicon = ["mdi-file-question-outline", "black"];
      }

      return dataicon;
    },
    },
    computed:{
        shower :{
            get() {
                if(this.show === true){
                    console.log("this.payload_package",this.payload_package);
                    this.loaddataprogress === true;
                    this.fn_getdetail_package();
                }
                return this.show
            }
        }
    }
}
</script>